// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrap[data-v-1c451750]{display:flex;justify-content:space-evenly}.wrap img[data-v-1c451750]{width:100%}.item[data-v-1c451750]{margin-right:20px;width:260px;cursor:pointer}.poster[data-v-1c451750]{width:100%}.item[data-v-1c451750]:last-child{margin-right:0}.el-divider[data-v-1c451750]{margin:0}.description[data-v-1c451750]{height:50px;line-height:50px;display:block;font-size:20px;font-weight:700;text-align:center}", ""]);
// Exports
module.exports = exports;
